import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyBananaIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./BananaIcon-30758adf.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyBananaIcon as P };
